/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { BakendHttpResponse } from '../bakend-http-response';

import { BackendAdditionalProjectInformationFieldDto } from '../models/backend-additional-project-information-field-dto';
import { BackendCopiedProjectFieldDto } from '../models/backend-copied-project-field-dto';
import { BackendProjectCompanyFieldDto } from '../models/backend-project-company-field-dto';
import { projectsAdditionalProjectInformationPartialUpdate } from '../fn/projects-other/projects-additional-project-information-partial-update';
import { projectsAdditionalProjectInformationPartialUpdate$FormData } from '../fn/projects-other/projects-additional-project-information-partial-update-form-data';
import { ProjectsAdditionalProjectInformationPartialUpdate$FormData$Params } from '../fn/projects-other/projects-additional-project-information-partial-update-form-data';
import { ProjectsAdditionalProjectInformationPartialUpdate$Params } from '../fn/projects-other/projects-additional-project-information-partial-update';
import { projectsAdditionalProjectInformationPartialUpdate$XWwwFormUrlencoded } from '../fn/projects-other/projects-additional-project-information-partial-update-x-www-form-urlencoded';
import { ProjectsAdditionalProjectInformationPartialUpdate$XWwwFormUrlencoded$Params } from '../fn/projects-other/projects-additional-project-information-partial-update-x-www-form-urlencoded';
import { projectsAdditionalProjectInformationRetrieve } from '../fn/projects-other/projects-additional-project-information-retrieve';
import { ProjectsAdditionalProjectInformationRetrieve$Params } from '../fn/projects-other/projects-additional-project-information-retrieve';
import { projectsAdditionalProjectInformationUpdate } from '../fn/projects-other/projects-additional-project-information-update';
import { projectsAdditionalProjectInformationUpdate$FormData } from '../fn/projects-other/projects-additional-project-information-update-form-data';
import { ProjectsAdditionalProjectInformationUpdate$FormData$Params } from '../fn/projects-other/projects-additional-project-information-update-form-data';
import { ProjectsAdditionalProjectInformationUpdate$Params } from '../fn/projects-other/projects-additional-project-information-update';
import { projectsAdditionalProjectInformationUpdate$XWwwFormUrlencoded } from '../fn/projects-other/projects-additional-project-information-update-x-www-form-urlencoded';
import { ProjectsAdditionalProjectInformationUpdate$XWwwFormUrlencoded$Params } from '../fn/projects-other/projects-additional-project-information-update-x-www-form-urlencoded';
import { projectsCopiedProjectPartialUpdate } from '../fn/projects-other/projects-copied-project-partial-update';
import { projectsCopiedProjectPartialUpdate$FormData } from '../fn/projects-other/projects-copied-project-partial-update-form-data';
import { ProjectsCopiedProjectPartialUpdate$FormData$Params } from '../fn/projects-other/projects-copied-project-partial-update-form-data';
import { ProjectsCopiedProjectPartialUpdate$Params } from '../fn/projects-other/projects-copied-project-partial-update';
import { projectsCopiedProjectPartialUpdate$XWwwFormUrlencoded } from '../fn/projects-other/projects-copied-project-partial-update-x-www-form-urlencoded';
import { ProjectsCopiedProjectPartialUpdate$XWwwFormUrlencoded$Params } from '../fn/projects-other/projects-copied-project-partial-update-x-www-form-urlencoded';
import { projectsCopiedProjectRetrieve } from '../fn/projects-other/projects-copied-project-retrieve';
import { ProjectsCopiedProjectRetrieve$Params } from '../fn/projects-other/projects-copied-project-retrieve';
import { projectsCopiedProjectUpdate } from '../fn/projects-other/projects-copied-project-update';
import { projectsCopiedProjectUpdate$FormData } from '../fn/projects-other/projects-copied-project-update-form-data';
import { ProjectsCopiedProjectUpdate$FormData$Params } from '../fn/projects-other/projects-copied-project-update-form-data';
import { ProjectsCopiedProjectUpdate$Params } from '../fn/projects-other/projects-copied-project-update';
import { projectsCopiedProjectUpdate$XWwwFormUrlencoded } from '../fn/projects-other/projects-copied-project-update-x-www-form-urlencoded';
import { ProjectsCopiedProjectUpdate$XWwwFormUrlencoded$Params } from '../fn/projects-other/projects-copied-project-update-x-www-form-urlencoded';
import { projectsProjectCompanyPartialUpdate } from '../fn/projects-other/projects-project-company-partial-update';
import { projectsProjectCompanyPartialUpdate$FormData } from '../fn/projects-other/projects-project-company-partial-update-form-data';
import { ProjectsProjectCompanyPartialUpdate$FormData$Params } from '../fn/projects-other/projects-project-company-partial-update-form-data';
import { ProjectsProjectCompanyPartialUpdate$Params } from '../fn/projects-other/projects-project-company-partial-update';
import { projectsProjectCompanyPartialUpdate$XWwwFormUrlencoded } from '../fn/projects-other/projects-project-company-partial-update-x-www-form-urlencoded';
import { ProjectsProjectCompanyPartialUpdate$XWwwFormUrlencoded$Params } from '../fn/projects-other/projects-project-company-partial-update-x-www-form-urlencoded';
import { projectsProjectCompanyRetrieve } from '../fn/projects-other/projects-project-company-retrieve';
import { ProjectsProjectCompanyRetrieve$Params } from '../fn/projects-other/projects-project-company-retrieve';
import { projectsProjectCompanyUpdate } from '../fn/projects-other/projects-project-company-update';
import { projectsProjectCompanyUpdate$FormData } from '../fn/projects-other/projects-project-company-update-form-data';
import { ProjectsProjectCompanyUpdate$FormData$Params } from '../fn/projects-other/projects-project-company-update-form-data';
import { ProjectsProjectCompanyUpdate$Params } from '../fn/projects-other/projects-project-company-update';
import { projectsProjectCompanyUpdate$XWwwFormUrlencoded } from '../fn/projects-other/projects-project-company-update-x-www-form-urlencoded';
import { ProjectsProjectCompanyUpdate$XWwwFormUrlencoded$Params } from '../fn/projects-other/projects-project-company-update-x-www-form-urlencoded';

@Injectable({ providedIn: 'root' })
export class BackendApiProjectsOtherService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `projectsAdditionalProjectInformationRetrieve()` */
  static readonly ProjectsAdditionalProjectInformationRetrievePath =
    '/api/projects/additional_project_information/{id}/';

  /**
   * Доп. параметры проекта.
   *
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsAdditionalProjectInformationRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsAdditionalProjectInformationRetrieve$Response(
    params: ProjectsAdditionalProjectInformationRetrieve$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendAdditionalProjectInformationFieldDto>> {
    return projectsAdditionalProjectInformationRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * Доп. параметры проекта.
   *
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsAdditionalProjectInformationRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsAdditionalProjectInformationRetrieve(
    params: ProjectsAdditionalProjectInformationRetrieve$Params,
    context?: HttpContext,
  ): Observable<BackendAdditionalProjectInformationFieldDto> {
    return this.projectsAdditionalProjectInformationRetrieve$Response(params, context).pipe(
      map(
        (
          r: BakendHttpResponse<BackendAdditionalProjectInformationFieldDto>,
        ): BackendAdditionalProjectInformationFieldDto => r.body,
      ),
    );
  }

  /** Path part for operation `projectsAdditionalProjectInformationUpdate()` */
  static readonly ProjectsAdditionalProjectInformationUpdatePath = '/api/projects/additional_project_information/{id}/';

  /**
   * Доп. параметры проекта.
   *
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsAdditionalProjectInformationUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectsAdditionalProjectInformationUpdate$Response(
    params: ProjectsAdditionalProjectInformationUpdate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendAdditionalProjectInformationFieldDto>> {
    return projectsAdditionalProjectInformationUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Доп. параметры проекта.
   *
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsAdditionalProjectInformationUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectsAdditionalProjectInformationUpdate(
    params: ProjectsAdditionalProjectInformationUpdate$Params,
    context?: HttpContext,
  ): Observable<BackendAdditionalProjectInformationFieldDto> {
    return this.projectsAdditionalProjectInformationUpdate$Response(params, context).pipe(
      map(
        (
          r: BakendHttpResponse<BackendAdditionalProjectInformationFieldDto>,
        ): BackendAdditionalProjectInformationFieldDto => r.body,
      ),
    );
  }

  /**
   * Доп. параметры проекта.
   *
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsAdditionalProjectInformationUpdate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  projectsAdditionalProjectInformationUpdate$XWwwFormUrlencoded$Response(
    params: ProjectsAdditionalProjectInformationUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendAdditionalProjectInformationFieldDto>> {
    return projectsAdditionalProjectInformationUpdate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Доп. параметры проекта.
   *
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsAdditionalProjectInformationUpdate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  projectsAdditionalProjectInformationUpdate$XWwwFormUrlencoded(
    params: ProjectsAdditionalProjectInformationUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendAdditionalProjectInformationFieldDto> {
    return this.projectsAdditionalProjectInformationUpdate$XWwwFormUrlencoded$Response(params, context).pipe(
      map(
        (
          r: BakendHttpResponse<BackendAdditionalProjectInformationFieldDto>,
        ): BackendAdditionalProjectInformationFieldDto => r.body,
      ),
    );
  }

  /**
   * Доп. параметры проекта.
   *
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsAdditionalProjectInformationUpdate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  projectsAdditionalProjectInformationUpdate$FormData$Response(
    params: ProjectsAdditionalProjectInformationUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendAdditionalProjectInformationFieldDto>> {
    return projectsAdditionalProjectInformationUpdate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Доп. параметры проекта.
   *
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsAdditionalProjectInformationUpdate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  projectsAdditionalProjectInformationUpdate$FormData(
    params: ProjectsAdditionalProjectInformationUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendAdditionalProjectInformationFieldDto> {
    return this.projectsAdditionalProjectInformationUpdate$FormData$Response(params, context).pipe(
      map(
        (
          r: BakendHttpResponse<BackendAdditionalProjectInformationFieldDto>,
        ): BackendAdditionalProjectInformationFieldDto => r.body,
      ),
    );
  }

  /** Path part for operation `projectsAdditionalProjectInformationPartialUpdate()` */
  static readonly ProjectsAdditionalProjectInformationPartialUpdatePath =
    '/api/projects/additional_project_information/{id}/';

  /**
   * Доп. параметры проекта.
   *
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsAdditionalProjectInformationPartialUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectsAdditionalProjectInformationPartialUpdate$Response(
    params: ProjectsAdditionalProjectInformationPartialUpdate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendAdditionalProjectInformationFieldDto>> {
    return projectsAdditionalProjectInformationPartialUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Доп. параметры проекта.
   *
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsAdditionalProjectInformationPartialUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectsAdditionalProjectInformationPartialUpdate(
    params: ProjectsAdditionalProjectInformationPartialUpdate$Params,
    context?: HttpContext,
  ): Observable<BackendAdditionalProjectInformationFieldDto> {
    return this.projectsAdditionalProjectInformationPartialUpdate$Response(params, context).pipe(
      map(
        (
          r: BakendHttpResponse<BackendAdditionalProjectInformationFieldDto>,
        ): BackendAdditionalProjectInformationFieldDto => r.body,
      ),
    );
  }

  /**
   * Доп. параметры проекта.
   *
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsAdditionalProjectInformationPartialUpdate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  projectsAdditionalProjectInformationPartialUpdate$XWwwFormUrlencoded$Response(
    params: ProjectsAdditionalProjectInformationPartialUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendAdditionalProjectInformationFieldDto>> {
    return projectsAdditionalProjectInformationPartialUpdate$XWwwFormUrlencoded(
      this.http,
      this.rootUrl,
      params,
      context,
    );
  }

  /**
   * Доп. параметры проекта.
   *
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsAdditionalProjectInformationPartialUpdate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  projectsAdditionalProjectInformationPartialUpdate$XWwwFormUrlencoded(
    params: ProjectsAdditionalProjectInformationPartialUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendAdditionalProjectInformationFieldDto> {
    return this.projectsAdditionalProjectInformationPartialUpdate$XWwwFormUrlencoded$Response(params, context).pipe(
      map(
        (
          r: BakendHttpResponse<BackendAdditionalProjectInformationFieldDto>,
        ): BackendAdditionalProjectInformationFieldDto => r.body,
      ),
    );
  }

  /**
   * Доп. параметры проекта.
   *
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsAdditionalProjectInformationPartialUpdate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  projectsAdditionalProjectInformationPartialUpdate$FormData$Response(
    params: ProjectsAdditionalProjectInformationPartialUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendAdditionalProjectInformationFieldDto>> {
    return projectsAdditionalProjectInformationPartialUpdate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Доп. параметры проекта.
   *
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsAdditionalProjectInformationPartialUpdate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  projectsAdditionalProjectInformationPartialUpdate$FormData(
    params: ProjectsAdditionalProjectInformationPartialUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendAdditionalProjectInformationFieldDto> {
    return this.projectsAdditionalProjectInformationPartialUpdate$FormData$Response(params, context).pipe(
      map(
        (
          r: BakendHttpResponse<BackendAdditionalProjectInformationFieldDto>,
        ): BackendAdditionalProjectInformationFieldDto => r.body,
      ),
    );
  }

  /** Path part for operation `projectsCopiedProjectRetrieve()` */
  static readonly ProjectsCopiedProjectRetrievePath = '/api/projects/copied_project/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsCopiedProjectRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsCopiedProjectRetrieve$Response(
    params: ProjectsCopiedProjectRetrieve$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendCopiedProjectFieldDto>> {
    return projectsCopiedProjectRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsCopiedProjectRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsCopiedProjectRetrieve(
    params: ProjectsCopiedProjectRetrieve$Params,
    context?: HttpContext,
  ): Observable<BackendCopiedProjectFieldDto> {
    return this.projectsCopiedProjectRetrieve$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendCopiedProjectFieldDto>): BackendCopiedProjectFieldDto => r.body),
    );
  }

  /** Path part for operation `projectsCopiedProjectUpdate()` */
  static readonly ProjectsCopiedProjectUpdatePath = '/api/projects/copied_project/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsCopiedProjectUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectsCopiedProjectUpdate$Response(
    params: ProjectsCopiedProjectUpdate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendCopiedProjectFieldDto>> {
    return projectsCopiedProjectUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsCopiedProjectUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectsCopiedProjectUpdate(
    params: ProjectsCopiedProjectUpdate$Params,
    context?: HttpContext,
  ): Observable<BackendCopiedProjectFieldDto> {
    return this.projectsCopiedProjectUpdate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendCopiedProjectFieldDto>): BackendCopiedProjectFieldDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsCopiedProjectUpdate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  projectsCopiedProjectUpdate$XWwwFormUrlencoded$Response(
    params: ProjectsCopiedProjectUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendCopiedProjectFieldDto>> {
    return projectsCopiedProjectUpdate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsCopiedProjectUpdate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  projectsCopiedProjectUpdate$XWwwFormUrlencoded(
    params: ProjectsCopiedProjectUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendCopiedProjectFieldDto> {
    return this.projectsCopiedProjectUpdate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendCopiedProjectFieldDto>): BackendCopiedProjectFieldDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsCopiedProjectUpdate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  projectsCopiedProjectUpdate$FormData$Response(
    params: ProjectsCopiedProjectUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendCopiedProjectFieldDto>> {
    return projectsCopiedProjectUpdate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsCopiedProjectUpdate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  projectsCopiedProjectUpdate$FormData(
    params: ProjectsCopiedProjectUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendCopiedProjectFieldDto> {
    return this.projectsCopiedProjectUpdate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendCopiedProjectFieldDto>): BackendCopiedProjectFieldDto => r.body),
    );
  }

  /** Path part for operation `projectsCopiedProjectPartialUpdate()` */
  static readonly ProjectsCopiedProjectPartialUpdatePath = '/api/projects/copied_project/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsCopiedProjectPartialUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectsCopiedProjectPartialUpdate$Response(
    params: ProjectsCopiedProjectPartialUpdate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendCopiedProjectFieldDto>> {
    return projectsCopiedProjectPartialUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsCopiedProjectPartialUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectsCopiedProjectPartialUpdate(
    params: ProjectsCopiedProjectPartialUpdate$Params,
    context?: HttpContext,
  ): Observable<BackendCopiedProjectFieldDto> {
    return this.projectsCopiedProjectPartialUpdate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendCopiedProjectFieldDto>): BackendCopiedProjectFieldDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsCopiedProjectPartialUpdate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  projectsCopiedProjectPartialUpdate$XWwwFormUrlencoded$Response(
    params: ProjectsCopiedProjectPartialUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendCopiedProjectFieldDto>> {
    return projectsCopiedProjectPartialUpdate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsCopiedProjectPartialUpdate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  projectsCopiedProjectPartialUpdate$XWwwFormUrlencoded(
    params: ProjectsCopiedProjectPartialUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendCopiedProjectFieldDto> {
    return this.projectsCopiedProjectPartialUpdate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendCopiedProjectFieldDto>): BackendCopiedProjectFieldDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsCopiedProjectPartialUpdate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  projectsCopiedProjectPartialUpdate$FormData$Response(
    params: ProjectsCopiedProjectPartialUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendCopiedProjectFieldDto>> {
    return projectsCopiedProjectPartialUpdate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsCopiedProjectPartialUpdate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  projectsCopiedProjectPartialUpdate$FormData(
    params: ProjectsCopiedProjectPartialUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendCopiedProjectFieldDto> {
    return this.projectsCopiedProjectPartialUpdate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendCopiedProjectFieldDto>): BackendCopiedProjectFieldDto => r.body),
    );
  }

  /** Path part for operation `projectsProjectCompanyRetrieve()` */
  static readonly ProjectsProjectCompanyRetrievePath = '/api/projects/project_company/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsProjectCompanyRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsProjectCompanyRetrieve$Response(
    params: ProjectsProjectCompanyRetrieve$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendProjectCompanyFieldDto>> {
    return projectsProjectCompanyRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsProjectCompanyRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsProjectCompanyRetrieve(
    params: ProjectsProjectCompanyRetrieve$Params,
    context?: HttpContext,
  ): Observable<BackendProjectCompanyFieldDto> {
    return this.projectsProjectCompanyRetrieve$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendProjectCompanyFieldDto>): BackendProjectCompanyFieldDto => r.body),
    );
  }

  /** Path part for operation `projectsProjectCompanyUpdate()` */
  static readonly ProjectsProjectCompanyUpdatePath = '/api/projects/project_company/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsProjectCompanyUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectsProjectCompanyUpdate$Response(
    params: ProjectsProjectCompanyUpdate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendProjectCompanyFieldDto>> {
    return projectsProjectCompanyUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsProjectCompanyUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectsProjectCompanyUpdate(
    params: ProjectsProjectCompanyUpdate$Params,
    context?: HttpContext,
  ): Observable<BackendProjectCompanyFieldDto> {
    return this.projectsProjectCompanyUpdate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendProjectCompanyFieldDto>): BackendProjectCompanyFieldDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsProjectCompanyUpdate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  projectsProjectCompanyUpdate$XWwwFormUrlencoded$Response(
    params: ProjectsProjectCompanyUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendProjectCompanyFieldDto>> {
    return projectsProjectCompanyUpdate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsProjectCompanyUpdate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  projectsProjectCompanyUpdate$XWwwFormUrlencoded(
    params: ProjectsProjectCompanyUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendProjectCompanyFieldDto> {
    return this.projectsProjectCompanyUpdate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendProjectCompanyFieldDto>): BackendProjectCompanyFieldDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsProjectCompanyUpdate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  projectsProjectCompanyUpdate$FormData$Response(
    params: ProjectsProjectCompanyUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendProjectCompanyFieldDto>> {
    return projectsProjectCompanyUpdate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsProjectCompanyUpdate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  projectsProjectCompanyUpdate$FormData(
    params: ProjectsProjectCompanyUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendProjectCompanyFieldDto> {
    return this.projectsProjectCompanyUpdate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendProjectCompanyFieldDto>): BackendProjectCompanyFieldDto => r.body),
    );
  }

  /** Path part for operation `projectsProjectCompanyPartialUpdate()` */
  static readonly ProjectsProjectCompanyPartialUpdatePath = '/api/projects/project_company/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsProjectCompanyPartialUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectsProjectCompanyPartialUpdate$Response(
    params: ProjectsProjectCompanyPartialUpdate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendProjectCompanyFieldDto>> {
    return projectsProjectCompanyPartialUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsProjectCompanyPartialUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectsProjectCompanyPartialUpdate(
    params: ProjectsProjectCompanyPartialUpdate$Params,
    context?: HttpContext,
  ): Observable<BackendProjectCompanyFieldDto> {
    return this.projectsProjectCompanyPartialUpdate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendProjectCompanyFieldDto>): BackendProjectCompanyFieldDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsProjectCompanyPartialUpdate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  projectsProjectCompanyPartialUpdate$XWwwFormUrlencoded$Response(
    params: ProjectsProjectCompanyPartialUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendProjectCompanyFieldDto>> {
    return projectsProjectCompanyPartialUpdate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsProjectCompanyPartialUpdate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  projectsProjectCompanyPartialUpdate$XWwwFormUrlencoded(
    params: ProjectsProjectCompanyPartialUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendProjectCompanyFieldDto> {
    return this.projectsProjectCompanyPartialUpdate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendProjectCompanyFieldDto>): BackendProjectCompanyFieldDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsProjectCompanyPartialUpdate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  projectsProjectCompanyPartialUpdate$FormData$Response(
    params: ProjectsProjectCompanyPartialUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendProjectCompanyFieldDto>> {
    return projectsProjectCompanyPartialUpdate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsProjectCompanyPartialUpdate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  projectsProjectCompanyPartialUpdate$FormData(
    params: ProjectsProjectCompanyPartialUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendProjectCompanyFieldDto> {
    return this.projectsProjectCompanyPartialUpdate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendProjectCompanyFieldDto>): BackendProjectCompanyFieldDto => r.body),
    );
  }
}
